module.exports = __webpack_public_path__ + "img/92.65788f0.png";